// @ts-nocheck
import {
  CALL_GROUP_ACL_MODULE,
  normalizeCallGroupEditOptions,
  DEFAULT_CALL_GROUP_EDIT_OPTIONS,
} from "./callGroupAcl";
import {
  AGENT_ACL_MODULE,
  normalizeAgentEditOptions,
  DEFAULT_AGENT_EDIT_OPTIONS,
} from "./agentAcl";
import {
  IVR_ACL_MODULE,
  normalizeIvrNodeOptions,
  DEFAULT_IVR_NODE_OPTIONS,
} from "./ivrAcl";
import { CALL_CENTRE_ACL_MODULE } from "./callCentreVoicemailAcl";
import { USERS_ACL_MODULE } from "./userEmailVerificationAcl";
import {
  DISPOSITION_FORMS_ACL_MODULE,
  CUSTOM_TIMING_ACL_OPTION,
} from "./dispositionFormsAcl";
import {
  areAclEditOptionsConfigured,
  isAclModuleOptionsRelevant,
  resolveAclOptionSelection,
} from "./aclModuleOptionsAccess";
import {
  VOICE_PLAN_ACL_MODULE,
  isVoicePlanAclActive,
  normalizeVoicePlanDirectionsForSave,
} from "./voicePlanAcl";
import {
  VOICE_LIBRARY_ACL_MODULE,
  isVoiceLibraryAclActive,
  isVoiceLibraryAclConfigured,
} from "./voiceLibraryAcl";
import {
  TTS_ACL_MODULE,
  isTtsOperatorConfigured,
  DEFAULT_TTS_OPERATOR,
} from "./ttsAcl";
import {
  AI_AGENT_ACL_MODULE,
  isAiAgentDescLimitConfigured,
  DEFAULT_AI_AGENT_DESC_CHAR_LIMIT,
} from "./aiAgentAcl";
import {
  AGENT_LEADS_ACL_MODULE,
  CUSTOM_LEADS_ACL_OPTION,
  isAgentLeadsCustomRelevant,
} from "./agentLeadsQuota";

/**
 * When creating/editing an ACL, pre-select a module's default options the first
 * time its options become relevant (edit/add/view_permission enabled). Defaults
 * are the per-option `defaultOn` flags, clamped to what the parent can grant —
 * not "everything grantable".
 */
export function applyDefaultAclModuleOptions(moduleName, entry, config = {}) {
  if (!entry || typeof entry !== "object") {
    return entry;
  }

  const next = { ...entry };
  const {
    parentGrantableCallGroupOptions = [],
    parentGrantableAgentOptions = [],
    parentGrantableIvrOptions = [],
    parentGrantableCallCentreVoicemail = null,
    parentGrantableUsersEmailVerification = null,
    parentGrantableDispositionTimingOptions = [],
    parentCanGrantCustomLeads = true,
    parentGrantableDirections = [],
    voiceTypeOptionsForEditor = [],
    categoryOptionsForEditor = [],
    languageOptionsForEditor = [],
  } = config;

  if (moduleName === CALL_GROUP_ACL_MODULE && isAclModuleOptionsRelevant(next)) {
    if (!areAclEditOptionsConfigured(next)) {
      next.edit_options = resolveAclOptionSelection(
        null,
        parentGrantableCallGroupOptions,
        DEFAULT_CALL_GROUP_EDIT_OPTIONS,
      );
    }
  }

  if (moduleName === AGENT_ACL_MODULE && isAclModuleOptionsRelevant(next)) {
    if (!areAclEditOptionsConfigured(next)) {
      next.edit_options = resolveAclOptionSelection(
        null,
        parentGrantableAgentOptions,
        DEFAULT_AGENT_EDIT_OPTIONS,
      );
    }
  }

  if (moduleName === IVR_ACL_MODULE && isAclModuleOptionsRelevant(next)) {
    if (!areAclEditOptionsConfigured(next)) {
      next.edit_options = resolveAclOptionSelection(
        null,
        parentGrantableIvrOptions,
        DEFAULT_IVR_NODE_OPTIONS,
      );
    }
  }

  if (moduleName === CALL_CENTRE_ACL_MODULE && isAclModuleOptionsRelevant(next)) {
    if (!areAclEditOptionsConfigured(next)) {
      next.edit_options = [];
    }
  }

  if (moduleName === USERS_ACL_MODULE && isAclModuleOptionsRelevant(next)) {
    if (!areAclEditOptionsConfigured(next)) {
      next.edit_options = [];
    }
  }

  if (moduleName === AGENT_LEADS_ACL_MODULE && isAgentLeadsCustomRelevant(next)) {
    if (!areAclEditOptionsConfigured(next)) {
      next.edit_options = parentCanGrantCustomLeads ? [CUSTOM_LEADS_ACL_OPTION] : [];
    }
  }

  if (moduleName === DISPOSITION_FORMS_ACL_MODULE && isAclModuleOptionsRelevant(next)) {
    if (!areAclEditOptionsConfigured(next)) {
      next.edit_options =
        parentGrantableDispositionTimingOptions.includes(CUSTOM_TIMING_ACL_OPTION)
          ? [CUSTOM_TIMING_ACL_OPTION]
          : [];
    }
  }

  if (moduleName === VOICE_PLAN_ACL_MODULE && isVoicePlanAclActive(next)) {
    const dirs = normalizeVoicePlanDirectionsForSave(
      next.plan_directions,
      parentGrantableDirections
    );
    if (dirs.length === 0 && parentGrantableDirections.length > 0) {
      next.plan_directions = [...parentGrantableDirections];
    }
  }

  if (moduleName === VOICE_LIBRARY_ACL_MODULE && isVoiceLibraryAclActive(next)) {
    if (!isVoiceLibraryAclConfigured(next)) {
      const types = voiceTypeOptionsForEditor.map((o) => o.value);
      const languages = languageOptionsForEditor.map((o) => o.value);
      if (types.length > 0) next.voice_types = [...types];
      if (languages.length > 0) next.languages = [...languages];
      delete next.categories;
    }
  }

  if (moduleName === TTS_ACL_MODULE && isAclModuleOptionsRelevant(next)) {
    if (!isTtsOperatorConfigured(next)) {
      next.tts_operator = DEFAULT_TTS_OPERATOR;
    }
  }

  if (moduleName === AI_AGENT_ACL_MODULE && isAclModuleOptionsRelevant(next)) {
    if (!isAiAgentDescLimitConfigured(next)) {
      next.description_char_limit = DEFAULT_AI_AGENT_DESC_CHAR_LIMIT;
    }
  }

  return next;
}
